import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { PickListModule } from 'primeng/picklist';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';

import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { TopbarComponent } from './topbar/topbar.component';
import { SidebarModule } from 'primeng/sidebar';
import { BadgeModule } from 'primeng/badge';
import { PortalComponent } from './pages/portal/portal.component';
import { PortalAddComponent } from './pages/portal-add/portal-add.component';
import { PortalUpdateComponent } from './pages/portal-update/portal-update.component';
import { ContractTypeComponent } from './pages/contract-type/contract-type.component';
import { ContractTypeAddComponent } from './pages/contract-type-add/contract-type-add.component';
import { ContractTypeUpdateComponent } from './pages/contract-type-update/contract-type-update.component';
import { DeviceModelComponent } from './pages/device-model/device-model.component';
import { DeviceModelAddComponent } from './pages/device-model-add/device-model-add.component';
import { DeviceModelUpdateComponent } from './pages/device-model-update/device-model-update.component';
import { LogoServiceComponent } from './pages/logo-service/logo-service.component';
import { LogoCustomerComponent } from './pages/logo-customer/logo-customer.component';
import { ContractComponent } from './pages/contract/contract.component';
import { ContractAddComponent } from './pages/contract-add/contract-add.component';
import { ContractUpdateComponent } from './pages/contract-update/contract-update.component';
import { TerminalComponent } from './pages/terminal/terminal.component';
import { TerminalAddComponent } from './pages/terminal-add/terminal-add.component';
import { TerminalUpdateComponent } from './pages/terminal-update/terminal-update.component';
import { LogoProjectComponent } from './pages/logo-project/logo-project.component';
import { CustomerTerminalComponent } from './pages/customer-terminal/customer-terminal.component';
import { CustomerTerminalAddComponent } from './pages/customer-terminal-add/customer-terminal-add.component';
import { CustomerTerminalUpdateComponent } from './pages/customer-terminal-update/customer-terminal-update.component';
import { MovementComponent } from './pages/movement/movement.component';
import { LoginComponent } from './pages/login/login.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { LoginGuard } from './pages/login/login.guard';
import { NbsUserComponent } from './pages/nbs-user/nbs-user.component';
import { DealerComponent } from './pages/dealer/dealer.component';
import { DealerAddComponent } from './pages/dealer-add/dealer-add.component';
import { DealerUpdateComponent } from './pages/dealer-update/dealer-update.component';
import { FileUploadModule } from 'primeng/fileupload';
import { EditorModule } from 'primeng/editor';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import {InputNumberModule} from 'primeng/inputnumber';
import { GeneralReportComponent } from './pages/general-report/general-report.component';
import { DealerReportComponent } from './pages/dealer-report/dealer-report.component';

@NgModule({
  declarations: [
    AppComponent,
    TopbarComponent,
    PortalComponent,
    PortalAddComponent,
    PortalUpdateComponent,
    ContractTypeComponent,
    ContractTypeAddComponent,
    ContractTypeUpdateComponent,
    DeviceModelComponent,
    DeviceModelAddComponent,
    DeviceModelUpdateComponent,
    LogoServiceComponent,
    LogoCustomerComponent,
    ContractComponent,
    ContractAddComponent,
    ContractUpdateComponent,
    TerminalComponent,
    TerminalAddComponent,
    TerminalUpdateComponent,
    LogoProjectComponent,
    CustomerTerminalComponent,
    CustomerTerminalAddComponent,
    CustomerTerminalUpdateComponent,
    MovementComponent,
    LoginComponent,
    NbsUserComponent,
    DealerComponent,
    DealerAddComponent,
    DealerUpdateComponent,
    GeneralReportComponent,
    DealerReportComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ButtonModule,
    TableModule,
    AccordionModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    InputTextModule,
    ConfirmDialogModule,
    DynamicDialogModule,
    TooltipModule,
    SidebarModule,
    BadgeModule, PickListModule,
    FormsModule, ReactiveFormsModule, FileUploadModule, EditorModule, ProgressSpinnerModule,InputNumberModule,
    ToastrModule.forRoot({
      closeButton: true,
      progressBar: true,
      positionClass: "toast-bottom-right",
      autoDismiss: true
    })
  ],
  providers: [LoginGuard, { provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule { }
